/*
  Click-to-copy for discount codes in the "Applicable offers" row.

  Uses one delegated listener on the document so it keeps working when the
  product info block is re-rendered on variant change. The guard below matters:
  offers-row.liquid emits this script tag each time it renders, so the file can
  be evaluated more than once on a page.
*/
if (!window.offerCodeCopyInit) {
  window.offerCodeCopyInit = true;

  (function () {
    var TOAST_MS = 2000;
    var toast;
    var toastTimer;
    var resetTimer;

    function getToast() {
      if (toast && document.body.contains(toast)) return toast;

      toast = document.createElement('div');
      toast.className = 'offers-toast';
      // polite + status so screen readers announce the copy without stealing focus
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
      return toast;
    }

    function showToast(message) {
      var el = getToast();
      el.textContent = message;

      // force a reflow so the transition runs when re-showing an existing toast
      void el.offsetWidth;
      el.classList.add('is-visible');

      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        el.classList.remove('is-visible');
      }, TOAST_MS);
    }

    // Fallback for browsers without the async clipboard API, and for pages not
    // served over https (navigator.clipboard is undefined in insecure contexts).
    function legacyCopy(text) {
      var area = document.createElement('textarea');
      area.value = text;
      area.setAttribute('readonly', '');
      area.style.position = 'fixed';
      area.style.top = '-9999px';
      document.body.appendChild(area);

      var selection = document.getSelection();
      var previous = selection.rangeCount > 0 ? selection.getRangeAt(0) : null;

      area.select();

      var ok = false;
      try {
        ok = document.execCommand('copy');
      } catch (e) {
        ok = false;
      }

      document.body.removeChild(area);

      if (previous) {
        selection.removeAllRanges();
        selection.addRange(previous);
      }

      return ok;
    }

    function copy(text) {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text);
      }
      return legacyCopy(text) ? Promise.resolve() : Promise.reject(new Error('copy failed'));
    }

    function markCopied(button) {
      button.classList.add('is-copied');
      clearTimeout(resetTimer);
      resetTimer = setTimeout(function () {
        button.classList.remove('is-copied');
      }, TOAST_MS);
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('.offer-card__code');
      if (!button) return;

      // The offers row sits inside the product form; never let this submit it.
      event.preventDefault();
      event.stopPropagation();

      var code = button.dataset.offerCode;
      if (!code) return;

      var copied = button.dataset.copiedText || 'Code copied!';
      var failed = button.dataset.failedText || 'Copy failed — code is ' + code;

      copy(code).then(
        function () {
          markCopied(button);
          showToast(copied);
        },
        function () {
          showToast(failed);
        }
      );
    });
  })();
}
